__turbopack_context__.v({
  "add-wishlist": "add-wishlist-component-module-scss-module__6ho1oa__add-wishlist",
  "add-wishlist__buttons": "add-wishlist-component-module-scss-module__6ho1oa__add-wishlist__buttons",
  "add-wishlist__form": "add-wishlist-component-module-scss-module__6ho1oa__add-wishlist__form",
  "add-wishlist__headline": "add-wishlist-component-module-scss-module__6ho1oa__add-wishlist__headline",
  "add-wishlist__icon": "add-wishlist-component-module-scss-module__6ho1oa__add-wishlist__icon",
  "add-wishlist__subtitle": "add-wishlist-component-module-scss-module__6ho1oa__add-wishlist__subtitle",
});
